/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import { motion } from 'framer-motion';
import { PriceHandler } from '../../redux/helper/CamelCase';

function ItemPriceTooltip({
    prod, hover, itemPriceValue, netDiscount, attribute, onMouseEnter, onMouseLeave,
}) {
    const marginClassMap = {
        total_price: '-mt-16',
        net_value: '-mt-6',
    };
    const marginClass = marginClassMap[attribute] || '';

    // Show Net Discount section if netDiscount prop was provided (even if null)
    // For Revised Value, Proposed Value, and Total Price (Trade EUB), netDiscount is always passed
    // For Sub Total/Net Value, netDiscount is not passed, so section won't show
    const showNetDiscount = netDiscount !== undefined;

    return (
        <motion.div
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
                duration: 0.8,
                delay: 0.5,
                ease: [0, 0.71, 0.2, 1.01],
            }}
            id="tooltip-discountPercentage"
            role="tooltip"
            className={`inline-block absolute ${hover ? 'visible' : 'invisible'} z-[5] sm:p-2.5 p-2 bg-white rounded-lg shadow-s2 sm:w-[225px] w-[210px] ml-2 ${marginClass}`}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <div className="flex items-center justify-between">
                <p className="text-sm font-normal text-[#555259]">Unit Rate </p>
                <p className="text-lg font-semibold text-[#555259]">
                    {PriceHandler(itemPriceValue)}
                </p>
            </div>
            {showNetDiscount && (
                <div className="flex items-center justify-between mt-1 pt-1 border-t border-[#E5E5E5]">
                    <p className="text-sm font-normal text-[#555259]">Net Discount </p>
                    <p className="text-lg font-semibold text-[#555259]">
                        {netDiscount !== null && netDiscount !== undefined ? Number(netDiscount).toFixed(2) : '0.00'}
                        %
                    </p>
                </div>
            )}
            <div className="tooltip-arrow" data-popper-arrow />
        </motion.div>
    );
}

export default ItemPriceTooltip;
